<template>
  <div class="col-12 col-lg-4 ml-auto text-lg-right artwork-state px-lg-0 px-xl-3">
    <div
      v-if="!auction || unsold"
      class="d-flex flex-column justify-content-between align-items-lg-end"
    >
      <p class="headings--h4 p-0"> {{ I18n.t("live_auctions.state.unsold") }} </p>
      <TakeInterest :artwork="artwork" />
    </div>
    <div v-else-if="sold">
      <p class="headings--h4 sold">
        {{ I18n.t("live_auctions.state.sold")}}
      </p>
      <p class="sold text--emphasis">
        {{ I18n.t("artworks.price", { price: formatPrice(auction.value) }) }}
      </p>
    </div>
    <div v-else-if="soldConditionally">
      <p class="headings--h4 sold-conditionally">
        {{ I18n.t("live_auctions.state.sold_conditionally")}}
      </p>
      <p class="sold-conditionally text--emphasis">
        {{ I18n.t("artworks.price", { price: formatPrice(auction.value) }) }}
      </p>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { formatNumber } from '@/shared/helpers';
  import ComputeArtworkState from '@/shared/mixins/compute_artwork_state';
  import TakeInterest from '@/shared/components/artwork_take_interest';

  export default {
    name: 'ArtworkState',
    components: {
      TakeInterest,
    },
    mixins: [ComputeArtworkState],
    props: {
      artwork: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['findAuction']),
      auction() {
        return this.findAuction(this.artwork.id);
      },
    },
    created() {
      this.formatPrice = formatNumber;
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/auctions_catalogs/show/components/artwork/artwork_state.vue?02848236